import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-report-progress-widget',
  templateUrl: './report-progress-widget.component.html',
  styleUrls: ['./report-progress-widget.component.scss']
})
export class ReportProgressWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  close() {
    localStorage.setItem('generatingReport', '0');
  }
}
